<template>
  <div class="flex items-center gap-[0.3rem]">
    <svg
      width="53"
      height="3"
      viewBox="0 0 53 3"
      fill="var(--foreground)"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="45" height="2" />
    </svg>
    <IconsGraphicsStarIcon fill="var(--foreground)" />
  </div>
</template>
